<template>
  <div class="animated fadeIn">
    <Forms ref="frmGroup"
      :title="'CADASTRO DE MOTIVOS'"
      :showClearButton="true"
      :showSaveButton="true"
      :showBackButton="true"
      v-on:Clear="onClear"
      v-on:Back="onBack"
      v-on:Save="onSave">
      <div class="form-group row">
        <div class="col-md-3">
          <label>
            <small v-show="form.nome.required" class="text-danger">*</small> Situação do motivo:
          </label>
          <div class="input-group">
            <b-form-group
              v-slot="{ reasonOption }"
            >
              <b-form-radio-group
                v-model="form.situacao.value"
                :options="form.situacao.options"
                :aria-describedby="reasonOption"
                name="reasonOptions"
                :required="form.situacao.required"
                :state="form.situacao.state"
                stacked
              ></b-form-radio-group>
            </b-form-group>
          </div>
        </div>
        <div class="col-md-12">
          <label>
            <small v-show="form.nome.required" class="text-danger">*</small> Motivo:
          </label>
          <div class="input-group">
            <b-form-input
              type="text"
              :placeholder="'Digite o Motivo'"
              v-model="form.nome.value"
              :size="form.nome.maxlength"
              :required="form.nome.required"
              :state="form.nome.state"
            ></b-form-input>
          </div>
        </div>
      </div>
    </Forms>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'

import ReasonModel from '@/shared/models/configurations/reasonmodel.js'
import ReasonForms from './reasonadd-form.js'
import ReasonLossRepository from '@/shared/http/repositories/configurations/reason.js'

export default {
  name: 'ReasonLossAdd',
  mixins: [ActionsForm],
  data () {
    return {
      data: ReasonModel,
      form: ReasonForms
    }
  },
  methods: {
    onBack () {
      this.$emit('Back')
    },
    onLoad () {
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onCreate () {
      loading.push()
      ReasonLossRepository.Create(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      this.data.id = parseInt(this.data.id)
      ReasonLossRepository.Update(this.data)
        .then((response) => {
          loading.close()
          this.$emit('Back')
          toast.success(this.$lang.Common.Alerts.Success)
        })
        .catch(this.onException)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/board/reason/components/add/reasonadd.vue